import { AbstractDimension } from '@orus.eu/dimensions'
import { type FrRcpaxeQuote, type FrRcpaxeTariffRefusal, quoteV3ToSerializedQuoteData } from '@orus.eu/pricing'
import type { Result } from '@orus.eu/result'

/**
 * The tariff refused the risk. Every refusal is also an exclusion known before pricing, so the quote only fails when an
 * agent ignores the exclusions.
 */
export type FrRcpaxeQuoteFailure = { type: 'tariff-refusal'; refusal: FrRcpaxeTariffRefusal }
export type FrRcpaxeQuoteResult = Result<FrRcpaxeQuote, FrRcpaxeQuoteFailure>

export class FrRcpaxeQuoteDimension<NAME extends string> extends AbstractDimension<NAME, FrRcpaxeQuoteResult> {
  override formatToString(value: FrRcpaxeQuoteResult): string {
    if (value.type === 'failure') return `NULL - ${value.problem.type} ${value.problem.refusal.rule}`
    return quoteV3ToSerializedQuoteData(value.output)
  }
}

export const frRcpaxeQuoteDimension = new FrRcpaxeQuoteDimension({
  name: 'frRcpaxeQuote',
  displayKeys: { name: 'dimension_name_fr_rcpaxe_quote' },
  considerForDifferenceComputationInUi: { client: false, partner: false, platform: true },
  includeInTrackingMessages: false,
  inputLocking: undefined,
} as const)
